// extracted by mini-css-extract-plugin
export default {"layout":"nKY46-oXhdiE3PMA4e6C3w=="};